/* Fades page content in as the customer scrolls to it. Runs on every page (loaded once from
   layout/theme.liquid) rather than per-section, since most of our own pages (FAQ, Contact, Our
   Story) are a single theme "page" section with just a heading block and a page-content block --
   there's no per-page wiring to maintain.

   Granularity: reveal each top-level section under #MainContent as one unit, UNLESS that section
   itself contains two or more independent theme blocks (e.g. a page's heading block + its
   page-content block) -- then reveal those blocks separately instead of the whole section as one
   lump. Our own custom .liquid sections (hero, gallery, trust badges, etc.) render fixed markup
   with no block ids, so they always fall into the first case and reveal as a whole section, which
   is exactly the right granularity for them.

   Only ever applies the .reveal class in JS, never bakes it into markup -- so a missing
   IntersectionObserver or prefers-reduced-motion simply means this whole function returns before
   touching anything, and every element renders normally with no opacity:0 starting state. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var targets = [];
    Array.prototype.forEach.call(main.children, function (section) {
      if (!section.classList || !section.classList.contains('shopify-section')) return;
      var blocks = Array.prototype.filter.call(
        section.querySelectorAll('[id^="shopify-block-"]'),
        function (b) { return !b.parentElement.closest('[id^="shopify-block-"]'); }
      );
      if (blocks.length >= 2) targets = targets.concat(blocks);
      else targets.push(section);
    });
    if (!targets.length) return;

    var vh = window.innerHeight;
    /* Reveal when the visible portion reaches 12% of the ELEMENT or half the VIEWPORT,
       whichever is smaller. A fixed 12%-of-element threshold stranded tall sections on
       phones: a section several screens high can never have 12% of itself visible at once,
       so it stayed at opacity:0 forever. The threshold ladder just makes the callback
       re-fire as more of the element scrolls in; the real gate is the height check. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var rootH = entry.rootBounds ? entry.rootBounds.height : vh;
        var need = Math.min(entry.boundingClientRect.height * 0.12, rootH * 0.5);
        if (entry.intersectionRect.height < need) return;
        entry.target.classList.add('reveal-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: [0, 0.02, 0.04, 0.08, 0.12], rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      var box = el.getBoundingClientRect();
      // Already on screen at load (above the fold, or a short page) -- show immediately.
      // Only content the customer actually scrolls TO gets the fade.
      if (box.top < vh * 0.9) return;
      /* Collapsed/empty sections (e.g. the Build-your-own configurator shell, display:none
         until its colour is picked) can never meet any reveal threshold - hiding them only
         strands the overlay that later opens INSIDE them: .reveal's transform makes the
         section the containing block for the sheet's position:fixed, and its opacity:0
         hides the sheet outright. Found live on Devin's phone, 14 Aug. */
      if (box.height < 40) return;
      el.classList.add('reveal');
      io.observe(el);
    });
  });
})();
